import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnInit } from '@angular/core';
import { SpinnerService } from 'shared-components';
import { CultivosService } from '../../../services/cultivos.service';

@Component({
  selector: 'app-pro-huertos',
  templateUrl: './huertos.component.html'
})
export class ProductoresHuertosComponent implements OnInit {

  private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

  public huertosList;
  public dropdownInfo: number;

  public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
  public currentPage = 0; // La paginación en back empieza por 0, como los arrays.
  public totalItems: number;
  public readonly visiblePages = 3;

  @Input() productorId;

  constructor(
    private readonly _translate: TranslateService,
    private readonly _spinnerService: SpinnerService,
    private readonly _cultivosService: CultivosService) { }

  ngOnInit() {
    this.getHuertosProductor();
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public pageChange(page) {
    this.dropdownInfo = -1;
    this.currentPage = page - 1;
    this.getHuertosProductor();
  }

  public itemsPerPageChange(items) {
    this.dropdownInfo = -1;
    this.currentPage = 0;
    this.itemsPerPage = items;
    this.getHuertosProductor();
  }

  public getHuertosProductor() {
    const productor = {
      productorId: this.productorId,
      numPagina: this.currentPage,
      tamPagina: this.itemsPerPage
    };
    this._spinnerService.showSpinner();
    this._cultivosService.getHuertosProductor(productor).toPromise().finally(() => {
      this._spinnerService.hideSpinner();
    }).then((resp) => {
      this.totalItems = resp.paginacionMeta.totalCount;
      this.huertosList = resp.lista;
    });
  }

  public showDetails(i: number) {
    this.dropdownInfo = this.dropdownInfo === i ? -1 : i;
    if (this.dropdownInfo !== -1 && window.innerWidth <= 1199) {
      setTimeout(() => {
        document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
      }, 50);
    }
  }

}
